const flatten = arrays => [].concat(...arrays);

export default flatten;